export enum TestIds {
  ReceiptBatchForm = 'ReceiptBatchForm',
  ReceiptBatchDetail = 'ReceiptBatchDetail',
}
